import { __exports as r } from "../../../../../../../../_virtual/sanitizer.js";
import { __require as f } from "../../../../../../isomorphic-dompurify@2.26.0_canvas@3.2.0/bundled_deps/isomorphic-dompurify/browser.js";
import { __require as m } from "./custom-sanitizers.js";
import { __require as _ } from "./config/index.js";
var n;
function z() {
  if (n) return r;
  n = 1, Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.sanitizeHtml = s;
  var u = i(f()), a = i(m()), o = i(_());
  function i(e) {
    return e && e.__esModule ? e : { default: e };
  }
  u.default.addHook("uponSanitizeElement", function(e, t) {
    a.default[e.tagName] && a.default[e.tagName](e, t);
  });
  function s(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return u.default.sanitize(e, (0, o.default)(t.config));
  }
  return r;
}
export {
  z as __require
};
